import { ReducerBuilder } from './reducerBuilder';
import { CountriesRequest } from 'acscp/api/requests/countriesRequest';
import { CountriesList } from 'acscp/api/models/countriesList';

export const countriesReducer =
    new ReducerBuilder<CountriesList>({
        countries: []
    })
        .successfulRequestCase(CountriesRequest, (state, response: CountriesList) => response)
        .build();
